<style lang="scss" src='./StationList.scss' scoped ></style>
<template src="./StationList.html"></template>

<script>
import VuePullRefresh from 'vue-pull-refresh';
import {
  mapState,
  mapActions,
  mapMutations,
  mapGetters,
} from 'vuex';
import { GetSensorRSSI } from '@/api/api';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import RefreshButton from '@/components/refreshButton/RefreshButton.vue';

export default {
  name: 'Stations',
  extends: CommonComponent,
  components: {
    'vue-pull-refresh': VuePullRefresh,
    RefreshButton
  },
  data() {
    return ({
      stationSelected: {},
      maxHeightSensor: 600,
      statusSelected: null,
      sensorUpdateInterval: null,
      valid: false,
      invalidText: this.$t('general.invalid')
    });
  },
  computed: {
    ...mapState('StationList', {
      stations: (state) => state.stations,
      loading: (state) => state.loading,
    }),
  },
  watch: {
    course() {
      this.loadData();
    },
  },
  methods: {
    refreshSensorList() {
      const self = this;
      // eslint-disable-next-line
      return new Promise(async function (resolve, reject) {
        await self.loadStations();
        resolve('ok');
      });
    },

    startIntervalToRefreshSensors() {
      this.sensorUpdateInterval = window.setInterval(this.redo, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

    redo(){
      // Pass true to hide loading
      this.loadStations(true)
    },

    refresh (){
      this.loadStations()
    },
    
    getRssiIcon(sensor) {
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
    },

    loadData() {
      this.loadStations();
    },

    async selectStation(station) {
      if (station) {
        this.stationSelected = station;
        this.$store.commit('setStation', station);
        this.$router.push('/station-details');
      }
    },

    adjustSensorListHeight() {
      const self = this;
      // eslint-disable-next-line
      const sensorHeightInterval = setInterval(function() {
        if (self.$refs.sensorsContainer) {
          self.maxHeightSensor = 
            (window.innerHeight - 60) - (self.$refs.sensorsContainer.getBoundingClientRect().top);
        }
      }, 0);
      // eslint-disable-next-line
      setTimeout(function() {
        clearInterval(sensorHeightInterval);
      }, 5000);
    },

    ...mapActions('StationList', ['loadStations']),
    ...mapMutations('StationList', ['setLoading', 'setSensorStatusFilter', 'setSensors']),
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(true);
    this.setShowBackground(true);
  },

  mounted() {
    this.adjustSensorListHeight();
    this.loadData();
    this.startIntervalToRefreshSensors();
    this.valid = this.G_canDo(this.consts.Security.Action.CLEAN_SENSOR, this.user, null);
  },

  beforeDestroy() {
    window.clearInterval(this.sensorUpdateInterval);
  },
};
</script>
